import React, { useContext }                         from "react";
import { StyleSheet, ScrollView }                    from "react-native";

import { Switch } from "react-router-dom";
import HashRoute from "~/routers/HashRoute";
import CustomerEditModal from "~/modals/CustomerEditModal";
import ParticipantHeader                             from "~/components/Participant/ParticipantHeader/index.web";
import ParticipantNotes                              from "~/components/Participant/ParticipantNotes/index.web";
import ParticipantFiles                              from "~/components/Participant/ParticipantFiles/index.web";
import ParticipantSchedule                           from "~/components/Participant/ParticipantSchedule/index.web";
import ParticipantEstimates                          from "~/components/Participant/ParticipantEstimates/index.web";
import ParticipantInvoices                           from "~/components/Participant/ParticipantInvoices/index.web";
import ParticipantVoicemails                         from "~/components/Participant/ParticipantVoicemails/index.web";
import ConversationContext                           from "~/contexts/ConversationContext";
import { ParticipantProvider }                       from "~/contexts/ParticipantContext";

import palette                                       from "~/styles/palette";


export default function ParticipantDetails({ customer: customerProp }) {
  const { conversation, loading, setParticipantFromCustomer } = useContext(ConversationContext);
  const { participant, customer } = conversation;

  if (loading && !participant) return null

  return (
    <ParticipantProvider value={{participant, customer}}>
      <ScrollView style={[styles.participant_details__container]}>
        <ParticipantHeader />
        <ParticipantNotes />
        <ParticipantVoicemails />
        <ParticipantFiles />
        <ParticipantSchedule />
        <ParticipantEstimates />
        <ParticipantInvoices />
      </ScrollView>

      <Switch>
        <HashRoute
          hash="#edit-customer"
          path="/"
          render={(routeProps) => (
            <CustomerEditModal
              {...routeProps}
              initial={customer || participant}
              onUpdate={setParticipantFromCustomer}
            />
          )}
        />
      </Switch>
    </ParticipantProvider>
  );
}

const styles = StyleSheet.create({
  participant_details__container: {
    padding: 8,
    backgroundColor: palette.lightest_grey,
  },
  participant_details_action_bar__label: {
    textAlign: "center",
    fontWeight: "500",
    paddingVertical: 6,
    fontSize: 12,
    color: palette.dark,
  },
  participant_details__header_email: {
    fontWeight: "500",
    color: palette.grey,
  },
});
